class ProtocolTimeline {
  constructor(root) {
    this.root = root;
    this.list = root.querySelector('[data-timeline-list]');
    this.rail = root.querySelector('[data-timeline-rail]');
    this.items = Array.from(root.querySelectorAll('[data-timeline-list] > .protocol-timeline__item'));
    this.triggers = Array.from(root.querySelectorAll('[data-timeline-trigger]'));
    this.dots = Array.from(root.querySelectorAll('[data-timeline-dot]'));
    this.panels = Array.from(root.querySelectorAll('[data-timeline-panel]'));

    if (this.triggers.length === 0) return;

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.setActive(Number(trigger.dataset.index));
        // Wait a frame for the active class / layout change to apply before re-measuring
        requestAnimationFrame(() => requestAnimationFrame(() => this.updateRail()));
      });
    });

    // Recalculate any time the list's size changes for any reason
    // (font load, image load, active state resizing a row, window resize, etc.)
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => this.updateRail());
      this.resizeObserver.observe(this.list);
      this.items.forEach((item) => this.resizeObserver.observe(item));
    } else {
      window.addEventListener('resize', () => this.updateRail());
    }

    requestAnimationFrame(() => this.updateRail());
    window.addEventListener('load', () => this.updateRail());
  }

  setActive(index) {
    this.items.forEach((item, i) => {
      const isActive = i === index;
      item.classList.toggle('is-active', isActive);
      const trigger = item.querySelector('[data-timeline-trigger]');
      if (trigger) trigger.setAttribute('aria-selected', String(isActive));
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', Number(panel.dataset.index) === index);
    });
  }

  updateRail() {
    if (!this.rail || !this.list || this.dots.length < 2) return;

    const listRect = this.list.getBoundingClientRect();
    const firstDot = this.dots[0];
    const lastDot = this.dots[this.dots.length - 1];

    const firstRect = firstDot.getBoundingClientRect();
    const lastRect = lastDot.getBoundingClientRect();

    const firstCenterY = firstRect.top + firstRect.height / 2 - listRect.top;
    const lastCenterY = lastRect.top + lastRect.height / 2 - listRect.top;
    const centerX = firstRect.left + firstRect.width / 2 - listRect.left;

    this.rail.style.left = centerX + 'px';
    this.rail.style.top = firstCenterY + 'px';
    this.rail.style.height = (lastCenterY - firstCenterY) + 'px';
  }
}

function initProtocolTimelines() {
  document.querySelectorAll('.protocol-timeline').forEach((root) => {
    if (root.dataset.timelineInit) return;
    root.dataset.timelineInit = 'true';
    const instance = new ProtocolTimeline(root);
    root._protocolTimelineInstance = instance;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProtocolTimelines);
} else {
  initProtocolTimelines();
}

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('.protocol-timeline');
  if (root) {
    delete root.dataset.timelineInit;
    new ProtocolTimeline(root);
  }
});